module.exports = __webpack_public_path__ + "static/media/remove-circle.c12c60aa.svg";